import { render, staticRenderFns } from "./anchored_vwap_tool.vue?vue&type=template&id=3dcb339a"
import script from "./anchored_vwap_tool.vue?vue&type=script&lang=js"
export * from "./anchored_vwap_tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports